<template>
  <section class="section bg-white institutional-section ibcgp-content-block" style="padding: 56px 0 !important">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <h2 class="text-center mb-4">
            Instituto voltado ao serviço público municipal
          </h2>
          <p class="text-justify mb-3">
            O Instituto Brasileiro de Ciências em Gestão Pública (IBCGP) atua junto a municípios,
            oferecendo apoio técnico e soluções digitais já utilizadas na rotina administrativa e tributária.
            Nossa atuação é pautada pela seriedade, pelo compromisso com a legalidade e pelo fortalecimento
            da gestão local.
          </p>
          <p class="text-justify mb-3">
            A <strong>afiliação ao instituto é gratuita</strong>. Após a afiliação, o município passa a ter acesso
            a um conjunto de ferramentas e processos digitais que apoiam a arrecadação, o cadastro e a transparência,
            sempre com acompanhamento institucional.
          </p>
          <p class="text-justify mb-0">
            Trabalhamos com equipe qualificada e histórico de projetos executados junto a entes públicos,
            o que permite às prefeituras confiar em processos estruturados e documentados.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'InstitutionalSection'
}
</script>

<style scoped>
.institutional-section h2 {
  font-size: 1.65rem;
  font-weight: 700;
  color: #02225b;
}
</style>
